import React, { useEffect, useState } from 'react';
import styles from "./ContactForm.module.css";
import api from '../../Utils/Network';
import marcusEvans from "../../Assets/ME_Logo_BLACK.svg"
import PropTypes from 'prop-types';

const ContactFound = ({ searchContactDetails, handleCloseModal, handleLinkOwner, formData, hubspotId, handleSecondFormClear, singleUser, handleSelectfromList, setShowAllFields }) => {
  const [loading, setLoading] = useState(false);
  const [loadingtwo, setLoadingtwo] = useState(false)
  const [isFull, setisFull] = useState(false);
  const [owner, setOwner] = useState(false)
  const [ownerLink, setOwnerLink] = useState(null)
  const [checkingOwnership, setCheckingOwnership] = useState(
    () => Boolean(hubspotId) && searchContactDetails?.length > 0
  );

  const handleClick = async () => {
    setLoading(true);
    try {
      await handleLinkOwner();
    } catch (error) {
      console.error('Error linking owner:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClicksecond = async (val) => {
    setLoadingtwo(true);
    try {
      await handleLinkOwner(val);
    } catch (error) {
      console.error('Error linking owner:', error);
    } finally {
      setLoadingtwo(false);
    }
  };

  const handleSelect = (contact, id) => {
    handleSelectfromList(contact)
  }

  const preflightCheck = async () => {
    const userType = localStorage.getItem('userType') || '';

    try {
      const { data } = await api.get(`/contact_owners_full?hubspot_contact_id=${hubspotId}&user_type=${userType}`);
      const { isAlreadyOwner, ContactHubspotUrl, isFull } = data?.ResponseData || {};

      setOwner(!!isAlreadyOwner);
      setisFull(!!isFull);

      // Set link only if the user is the owner
      if (isAlreadyOwner && ContactHubspotUrl) {
        setOwnerLink(ContactHubspotUrl);
      } else {
        setOwnerLink(null);
      }

    } catch (error) {
      console.error('Error making the preflight check:', error);
    } finally {
      setCheckingOwnership(false);
    }
  };




  useEffect(() => {
    if (searchContactDetails.length > 0 && hubspotId) {
      setCheckingOwnership(true);
      preflightCheck();
    } else {
      setCheckingOwnership(false);
    }
  }, [hubspotId, searchContactDetails]);

  const handleContactAdmin = () => {
    const email = 'monikam@marcusevansuk.com , anushreed@marcusevansuk.com';
    const subject = encodeURIComponent('Contact Ownership Request');
    const body = encodeURIComponent(
      `Hello,\n\nI would like to request ownership of a contact:\n\nFirst Name: ${singleUser?.FirstName}\nLast Name: ${singleUser?.Surname}\nCompany Name: ${singleUser?.CompanyName
      }\n\nPlease assist me.\n\nThank you.`
    );
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
    handleCloseModal();
    handleSecondFormClear();
  };

  return (
    <>
      <div className={styles.WrapperimgCon}>
        <div className={styles.imgContainer}>
          <img src={marcusEvans} alt="marcus evans" className={styles.meImage} />
        </div>
      </div>


      <p className={styles.contactContainer}>Similar/Confirmed Matches found</p>
      {/* <div className={styles.dedicatedContainer}>
        <img src={dedicated_ip_board} className={styles.ddimage} alt="dedicated ip board" />
      </div> */}
      <div className={`${styles.contactDetails} ${searchContactDetails?.length > 2 ? styles.scrollable : ''}`}>
        {searchContactDetails?.map((contact, index) => (
          <button
            key={contact?.ContactId}
            className={`${styles.radioContainer} ${styles.buttonReset} ${(searchContactDetails.length === 1 || hubspotId == contact?.ContactHubSpotId)
              ? styles.borderHighlight
              : ''
              } ${formData?.email === contact.EmailAddress ? styles.emailMatch : styles.noEmailMatch
              }`}
            onClick={searchContactDetails.length > 1 ? () => handleSelect(contact, contact?.ContactHubSpotId) : undefined}
            aria-pressed={formData?.email === contact.EmailAddress} // Keeps track of selection
          >
            <div className={styles.contactDetail}>
              <p className={`${styles.color} ${styles.spacing}`}><span className={styles.fontBold}>First Name</span>: {contact?.FirstName}</p>
              <p className={`${styles.color} ${styles.spacing}`}><span className={styles.fontBold}>Last Name</span>: {contact?.Surname}</p>
              <p className={`${styles.color} ${styles.spacing}`}><span className={styles.fontBold}>Company</span>: {contact?.CompanyName}</p>
              {formData?.email === contact?.EmailAddress && contact?.EmailAddress && (
                <p className={`${styles.color} ${styles.spacing}`}>
                  <span className={styles.fontBold}>Email</span>: {contact?.EmailAddress}
                </p>
              )}
            </div>
          </button>
        ))}
      </div>


      {(isFull && !owner) && <p className={styles.marginTop}>The dedicated numbers of owners are complete for this contact. Please contact admin/support to take ownership of this contact.</p>}
      {owner && (
        <p className={`${styles.marginTop} ${styles.textAlignc}  `}>You are already an owner of this contact.</p>
      )}
      <div className={styles.ButtonForm}>
        {checkingOwnership && (
          <div className={styles.ownershipLoading}>
            <span className={styles.spinner} />
            <p>Checking contact ownership...</p>
          </div>
        )}

        {!checkingOwnership && owner && (
          // If the user is already the owner, disable the button and change its color to gray
          <>
            <button
              className={`${styles.pButton} ${styles.disabledButton}`}
              disabled={true}
              style={{ backgroundColor: 'gray', cursor: 'not-allowed', display: 'block', width: '100%' }}
            >
              You are already the owner
            </button>

            {ownerLink && (
              <a
                href={ownerLink}
                className={styles.pButton}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'block',
                  marginTop: '16px',
                  textAlign: 'center',
                  textDecoration: 'none',
                  cursor: 'pointer'
                }}
              >
                View Contact Details
              </a>
            )}

            <button
              className={styles.pButton}
              onClick={() => {
                setShowAllFields(true);
                handleCloseModal();
              }}
              style={{ display: 'block', width: '100%', marginTop: '16px' }}
            >
              Contact not found? Create new
            </button>

          </>
        )
        }

        {
          !checkingOwnership && (!owner && isFull) && (
            // If the user is not the owner and isFull is true, show "Contact Admin/Support"
            <button
              className={styles.pButton}
              onClick={handleContactAdmin}
              style={{ display: 'block', width: '100%' }}
            >
              Contact Admin/Support
            </button>
          )
        }

        {
          !checkingOwnership && (!owner && !isFull) && (
            // If the user is not the owner and isFull is false, show "Proceed with ownership"
            <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
              <button
                className={styles.pButton}
                onClick={handleClick}
                disabled={loading}
                style={{ display: 'block', width: '100%' }}
              >
                {loading ? 'Processing...' : 'Own & Create a New Contact'}
              </button>

              <button
                className={styles.pButton}
                onClick={() => handleClicksecond(true)} // Adjust the onClick as per your requirement
                disabled={loadingtwo}
                style={{ display: 'block', width: '100%' }}
              >
                {loadingtwo ? 'Processing...' : 'Own & Redirect to HubSpot'}
              </button>

              {
                <button
                  className={styles.pButton}
                  onClick={() => {
                    setShowAllFields(true);
                    handleCloseModal();
                  }}
                  style={{ display: 'block', width: '100%' }}
                >
                  Contact not found? Create new
                </button>
              }

            </div>
          )
        }

        <div style={{ marginTop: "10px" }}>
          <button onClick={handleCloseModal} className={styles.skipButton} style={{ display: 'block', width: '100%' }}>
            Skip adding this contact
          </button>
        </div>
      </div>
    </>
  )
}

ContactFound.propTypes = {
  searchContactDetails: PropTypes.any,
  handleCloseModal: PropTypes.any,
  handleLinkOwner: PropTypes.any,
  formData: PropTypes.any,
  hubspotId: PropTypes.any,
  handleSecondFormClear: PropTypes.any,
  singleUser: PropTypes.any,
  handleSelectfromList: PropTypes.any,
  setShowAllFields: PropTypes.any,
};

export default ContactFound

const data = [
  {
    FirstName: 'John',
    Surname: 'Doe',
    CompanyName: 'Example Corp',
    EmailAddress: 'john.doe@example.com',
    ContactHubSpotId: '001',
  },
  {
    FirstName: 'Jane',
    Surname: 'Smith',
    CompanyName: 'Tech Solutions',
    EmailAddress: 'jane.smith@techsolutions.com',
    ContactHubSpotId: '002',
  },
  {
    FirstName: 'Alice',
    Surname: 'Johnson',
    CompanyName: 'Innovative Designs',
    EmailAddress: 'alice.johnson@innodesigns.com',
    ContactHubSpotId: '003',
  },
  {
    FirstName: 'Bob',
    Surname: 'Brown',
    CompanyName: 'Creative Minds',
    EmailAddress: 'bob.brown@creativeminds.com',
    ContactHubSpotId: '004',
  },
];

